/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Passkey_Failed_BodyInputs */

const en_signin_passkey_failed_body = /** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again, or sign in with an email link and add the passkey again in your account.`)
};

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const ar_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const he_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const ur_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const es_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const fr_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const de_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const pt_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const hi_signin_passkey_failed_body = en_signin_passkey_failed_body;

/** @type {(inputs: Signin_Passkey_Failed_BodyInputs) => LocalizedString} */
const bn_signin_passkey_failed_body = en_signin_passkey_failed_body;

/**
* | output |
* | --- |
* | "Try again, or sign in with an email link and add the passkey again in your account." |
*
* @param {Signin_Passkey_Failed_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_passkey_failed_body = /** @type {((inputs?: Signin_Passkey_Failed_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Passkey_Failed_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_passkey_failed_body(inputs)
	if (locale === "he") return he_signin_passkey_failed_body(inputs)
	if (locale === "ur") return ur_signin_passkey_failed_body(inputs)
	if (locale === "es") return es_signin_passkey_failed_body(inputs)
	if (locale === "fr") return fr_signin_passkey_failed_body(inputs)
	if (locale === "de") return de_signin_passkey_failed_body(inputs)
	if (locale === "pt") return pt_signin_passkey_failed_body(inputs)
	if (locale === "hi") return hi_signin_passkey_failed_body(inputs)
	if (locale === "bn") return bn_signin_passkey_failed_body(inputs)
	return /** @type {LocalizedString} */ ("Try again, or sign in with an email link and add the passkey again in your account.")
});